import * as _4 from 'lodash4';

export class APIntakeSurveyNKHelper {
  private intakeSurveyNKConfigvalues = {
    'academicplan-intake_time_commitment_nk': 'AP_TIME_COMMITMENT',
    'academicplan-intake_term_preference_nk': 'AP_TERM_PREFERENCE',
    'academicplan-intake_generate_plan_nk': 'AP_GENERATE_PLAN'
  };
  constructor(private appConfigModel: any, private InTakeSurveyConstants: any) {}

  defaultNKforIntakeSurveyConfig(surveyConfigKey: string) {
    return _4.get(this.intakeSurveyNKConfigvalues, `${surveyConfigKey}`, '');
  }
  get intakeSurveyTimeCommitmentNK() {
    let timeCommitmentNk = this.appConfigModel.getConfigProperty('academicplan-intake_time_commitment_nk');
    if (_4.isEmpty(timeCommitmentNk)) {
      timeCommitmentNk = this.defaultNKforIntakeSurveyConfig('academicplan-intake_time_commitment_nk');
    }
    return timeCommitmentNk;
  }
  get intakeSurveyTermPreferenceNK() {
    let termPreferenceNK = this.appConfigModel.getConfigProperty('academicplan-intake_term_preference_nk');
    if (_4.isEmpty(termPreferenceNK)) {
      termPreferenceNK = this.defaultNKforIntakeSurveyConfig('academicplan-intake_term_preference_nk');
    }
    return termPreferenceNK;
  }
  get intakeSurveyNK() {
    let intakeSurveyNK = this.appConfigModel.getConfigProperty(this.InTakeSurveyConstants['AP_INTAKE_SURVEY_NK']);
    if (_4.isEmpty(intakeSurveyNK)) {
      intakeSurveyNK = 'ACADEMIC_PLAN_INTAKE_SURVEY';
    }
    return intakeSurveyNK;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPIntakeSurveyNKHelper', APIntakeSurveyNKHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/helpers/intake_survey_nk_helper.ts